import { Container, Header, Grid } from 'semantic-ui-react';
import Parser from 'html-react-parser';
import DOMPurify from 'dompurify';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { breakpoints, verticalGutter } from '../../styles';
import { Formatters } from '../../utils';

const StyledArticle = styled(Container)`
  &.ui.container {
    margin-top: ${verticalGutter / 2}rem;
    margin-bottom: ${verticalGutter / 2}rem;

    &:first-child {
      margin-top: ${verticalGutter}rem;
    }
    @media screen and (min-width: ${breakpoints.computer}) {
      max-width: 800px !important;
    }
  }
`;

const AnnouncementDetail = ({ data: announcement }) => {
  return (
    <Fragment>
      <StyledArticle>
        <div className="container__inner">
          <Header as="h1">
            <small>Announcements</small>
            {announcement.title}
          </Header>
          <time
            dateTime={Formatters.date(announcement.createdAt, 'YYYY-MM-DD')}
          >
            {Formatters.date(announcement.createdAt, 'MMMM Do, YYYY')}
          </time>
        </div>
      </StyledArticle>

      <StyledArticle>
        <div className="container__inner">
          <Grid>
            {announcement.leadImage && (
              <Grid.Row>
                <Grid.Column>
                  <img src={announcement.leadImage} alt={announcement.title} />
                </Grid.Column>
              </Grid.Row>
            )}
            {announcement.body && (
              <Grid.Row>
                <Grid.Column>
                  {Parser(DOMPurify.sanitize(announcement.body))}
                </Grid.Column>
              </Grid.Row>
            )}
          </Grid>
        </div>
      </StyledArticle>
    </Fragment>
  );
};

export default AnnouncementDetail;



// WEBPACK FOOTER //
// ./src/pages/Announcement/AnnouncementDetail.js